import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"main hide-overflow\">\r\n    <img class=\"engagement-image\" src=\"\" alt=\"\" data-image-url=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":3,"column":64},"end":{"line":3,"column":73}}}) : helper)))
    + "\">\r\n    <div class=\"v-center\">\r\n      <div class=\"row\">\r\n        <div class=\"column small-12\">\r\n          <h2 class=\"headline cnx-light\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":7,"column":41},"end":{"line":7,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          <p class=\"show-for-medium-only spa-btn-group\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"primaryButton") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":12},"end":{"line":16,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secondaryButtonLink") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":24,"column":19}}})) != null ? stack1 : "")
    + "          </p>\r\n          <p class=\"show-for-large-up spa-btn-group\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"primaryButton") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":12},"end":{"line":34,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secondaryButtonLink") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":12},"end":{"line":42,"column":19}}})) != null ? stack1 : "")
    + "          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a id=\"engagement-primary-med\"\r\n                  href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"primaryButtonLink") || (depth0 != null ? lookupProperty(depth0,"primaryButtonLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"primaryButtonLink","hash":{},"data":data,"loc":{"start":{"line":11,"column":24},"end":{"line":11,"column":45}}}) : helper)))
    + "\"\r\n                  class=\"spa-btn spa-btn--small spa-btn--primary\"\r\n              >\r\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"primaryButton") || (depth0 != null ? lookupProperty(depth0,"primaryButton") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"primaryButton","hash":{},"data":data,"loc":{"start":{"line":14,"column":16},"end":{"line":14,"column":35}}}) : helper))) != null ? stack1 : "")
    + "\r\n              </a>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a id=\"engagement-secondary-med\"\r\n                 href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"secondaryButtonLink") || (depth0 != null ? lookupProperty(depth0,"secondaryButtonLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"secondaryButtonLink","hash":{},"data":data,"loc":{"start":{"line":19,"column":23},"end":{"line":19,"column":46}}}) : helper)))
    + "\"\r\n                 class=\"spa-btn spa-btn--small spa-btn--secondary\"\r\n              >\r\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"secondaryButton") || (depth0 != null ? lookupProperty(depth0,"secondaryButton") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"secondaryButton","hash":{},"data":data,"loc":{"start":{"line":22,"column":16},"end":{"line":22,"column":37}}}) : helper))) != null ? stack1 : "")
    + "\r\n              </a>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a id=\"engagement-primary-large\"\r\n                 href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"primaryButtonLink") || (depth0 != null ? lookupProperty(depth0,"primaryButtonLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"primaryButtonLink","hash":{},"data":data,"loc":{"start":{"line":29,"column":23},"end":{"line":29,"column":44}}}) : helper)))
    + "\"\r\n                 class=\"spa-btn spa-btn--medium spa-btn--primary\"\r\n              >\r\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"primaryButton") || (depth0 != null ? lookupProperty(depth0,"primaryButton") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"primaryButton","hash":{},"data":data,"loc":{"start":{"line":32,"column":16},"end":{"line":32,"column":35}}}) : helper))) != null ? stack1 : "")
    + "\r\n              </a>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a id=\"engagement-primary-large\"\r\n                 href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"secondaryButtonLink") || (depth0 != null ? lookupProperty(depth0,"secondaryButtonLink") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"secondaryButtonLink","hash":{},"data":data,"loc":{"start":{"line":37,"column":23},"end":{"line":37,"column":46}}}) : helper)))
    + "\"\r\n                 class=\"spa-btn spa-btn--medium spa-btn--secondary\"\r\n              >\r\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"secondaryButton") || (depth0 != null ? lookupProperty(depth0,"secondaryButton") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"secondaryButton","hash":{},"data":data,"loc":{"start":{"line":40,"column":16},"end":{"line":40,"column":37}}}) : helper))) != null ? stack1 : "")
    + "\r\n              </a>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":48,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/engagement-nl-module",
  "version": "1.0.2",
  "id": "engagementNlModule",
  "containerID": "homeLoansEngagementNlModule",
  "moduleName": "home-loans-engagement-nl-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "engagement-nl-module",
  "data": {
    "init": "engagementNlModuleJS",
    "options": {
      "var1": "I am a placeholder CMS JCR",
      "var2": 3
    }
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8"
  },
  "stores": []
};

/**
 * @export
 * @class engagementNlModuleJS
 * @extends {Module}
 */
class engagementNlModuleJS extends Module {
  /**
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @method init
   * @desc Initialize module
   * @returns {void}
   */
  init() {
    this.setImageSrc();
  }

  /**
  * @description Sets the image src via data attribute
  * @returns {void}
  */
  setImageSrc() {
    const image = this.settings.target.querySelector('.engagement-image');
    const url = image.getAttribute('data-image-url');
    image.setAttribute('src', url);
  }
}
registerModuleClass({
  moduleClass: engagementNlModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { engagementNlModuleJS as default, moduleConfig };
